import React from "react"

import FacilitiesFormProvider, {
  Props
} from "context/Settings/PropertyManagement/Facilities/forms/category/Provider"
import FacilitiesFormView from "context/Settings/PropertyManagement/Facilities/forms/category/View"

const FacilitiesForm: React.FC<Props> = ({ showTable, data }) => (
  <FacilitiesFormProvider showTable={showTable} data={data}>
    <FacilitiesFormView />
  </FacilitiesFormProvider>
)

export default FacilitiesForm
